
import React from 'react';
import {Link} from 'react-router-dom';


export default ({to}) => (
    <div className="text-center mt-2">
        <Link to={to} hash="top" className="btn btn-success" onClick={function(){window.scrollTo(0,0);return true;}}>
            Продолжить <i className="bi bi-chevron-right" />
        </Link>
    </div>
);